export function PurchaseOrderTermsConditions({
  showGstApplicability = false,
  gstApplicability = '',
}) {
  if (!showGstApplicability) {
    return null
  }

  return (
    <div className="space-y-3 border-t border-slate-200 pt-5">
      {/* Section Header */}
      <div className="flex items-center gap-2">
        <div className="h-6 w-1 rounded bg-[#1F3FAF]" />

        <h3 className="text-sm font-bold uppercase tracking-wider text-[#080d25]">
          Terms & Conditions
        </h3>
      </div>

      {/* GST Applicability */}
      <div className="rounded-2xl border border-dashed border-[#9EB5E5] bg-white p-4 sm:p-5">
        <label
          htmlFor="po-gst-applicability"
          className="mb-1.5 block text-sm font-medium text-slate-800"
        >
          GST Applicability
        </label>

        <input
          id="po-gst-applicability"
          type="text"
          value={gstApplicability}
          readOnly
          placeholder="Vendor state will determine tax applicability"
          className="w-full rounded-xl border border-slate-200 bg-slate-50 px-3.5 py-2.5 text-sm text-slate-600 shadow-xs outline-none"
        />
      </div>
    </div>
  )
}
